module.exports = __webpack_public_path__ + "static/media/SHSProdIcons__TV_with_Remote.f11de8fa.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons__TV_with_Remote.svg
// module id = 1601
// module chunks = 0